export default __webpack_public_path__ + "static/media/star.5d25088f.svg";